import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const TradegateKursServiceConfig = {
  name: "TradegateKurs",
  annotations: []
} as ServiceConfig;